import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
/**
 * Generated class for the RouteonmapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

declare var google;

@Component({
  selector: 'page-routeonmap',
  templateUrl: 'routeonmap.html',
})
export class RouteonmapPage {
  @ViewChild('mapFull') mapElement: ElementRef;
  ppid: any
  poiname: any
  radius: any
  lonpoi: any
  latpoi: any
  lonvisited: any
  latvisited: any
  dist: any
  Map: any
  dtvisited: any

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    //this.ppid = navParams.get('ppid')
    this.dist = navParams.get('dist')
    this.poiname = navParams.get('name')
    this.radius = navParams.get('radius')
    this.lonpoi = navParams.get('lonpoi')
    this.latpoi = navParams.get('latpoi')
    this.lonvisited = navParams.get('lonvisited')
    this.latvisited = navParams.get('latvisited')
    this.dtvisited = navParams.get('visiteddt')
  }

  ionViewDidLoad() {
    this.initMap()
  }


  initMap() {
    var _pts = []
    _pts.push({ lon: this.lonvisited, lat: this.latvisited })
    _pts.push({ lon: this.lonpoi, lat: this.latpoi })
    var _optimum = 'shortest'
    var _TollRoad = "no";
    var _Highways = "no";
    var _Ferry = "no";

    var _that = this
    var mapOptions = {
      zoom: 15,
      maxZoom: 20,
      minZoom: 6,
    }
    _that.Map = new google.maps.Map(_that.mapElement.nativeElement, mapOptions);
    _that.gn._Post('/api/gn/insertgoogleuse', { cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId), path: _that.gn.crypt('rep map') }, function () {
    })

    var bounds = new google.maps.LatLngBounds();

    var myLatLng = { lat: parseFloat(_that.latvisited), lng: parseFloat(_that.lonvisited) };

    if ((parseInt(_that.dist)) > _that.radius) {
      /*no*/var marker = new google.maps.Marker({
        position: myLatLng,
        map: _that.Map,
        icon: { path: google.maps.SymbolPath.CIRCLE, scale: 7, strokeWeight: 2, fillColor: '#f53d3d', fillOpacity: 1, strokeColor: '#aa0909' }
      });
    } else {
      /*no*/var marker = new google.maps.Marker({
        position: myLatLng,
        map: _that.Map,
        icon: { path: google.maps.SymbolPath.CIRCLE, scale: 7, strokeWeight: 2, fillColor: '#488aff', fillOpacity: 1, strokeColor: '#0054e6' }
      });
    }

    bounds.extend({ lat: parseFloat(_that.latvisited), lng: parseFloat(_that.lonvisited) });
    var _content = `
          <div style="font-size:12px;">`+ _that.dic.l["markedvisit"] + ` <br>` + _that.dtvisited + ` <br>` + _that.dic.l["distancevisit"] + `: ` + (parseInt(_that.dist)) + ` m<br>(` + _that.dic.l["allowed"] + `: ` + _that.radius + ` m)</div>
        
        `
    var infowindow = new google.maps.InfoWindow({
      content: _content
    });
    infowindow.open(_that.Map, marker);

    var myLatLng1 = { lat: parseFloat(_that.latpoi), lng: parseFloat(_that.lonpoi) };
    /*no*/var marker = new google.maps.Marker({
      position: myLatLng1,
      map: _that.Map,
      icon: { path: google.maps.SymbolPath.CIRCLE, scale: 7, strokeWeight: 2, fillColor: '#32db64', fillOpacity: 1, strokeColor: '#1fad49' }
    });

    var circle = {
      strokeColor: "#32db64",
      strokeOpacity: 0.6,
      strokeWeight: 2,
      fillColor: "#32db64",
      fillOpacity: 0.2,
      map: _that.Map,
      center: myLatLng1,
      radius: parseInt(_that.radius)
    };
    var _circle = new google.maps.Circle(circle)
    _circle.bindTo('center', marker, 'position');

    bounds.extend({ lat: parseFloat(_that.latpoi), lng: parseFloat(_that.lonpoi) });

    _that.Map.fitBounds(bounds);

    var _content = `
            <div style="font-size:12px;">`+ _that.poiname + `</div>
          `
    var infowindow = new google.maps.InfoWindow({
      content: _content
    });
    infowindow.open(_that.Map, marker);

  }

}



/*

datetime: "2018-05-30T08:37:06.601Z"

latitude: "41.860331"

longitude: "20.927794"

speed: "120.240000"

vehicleid: 2962

*/


// WEBPACK FOOTER //
// ./src/pages/routing/routeonmap/routeonmap.ts